import Types from '../Types'

export default (status = null) => ({
    type: Types.APP.SETSTATUS,
    status
})



// WEBPACK FOOTER //
// ./src/actions/app/SetStatusAction.js